import http from "./http";
/*
 ** 采购管理接口
 */
var baseUrl = "/contract-web";

//采购计划列表
const getBidPlan = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/plan/list", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//查询当前招标计划编码序号
const getBidPlanNo = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/plan/code", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


/*
 ** 删除采购计划列表一条数据
 */
 const deletebidPlan = data => {
    return new Promise((resolve, reject) => {
        http
            .delete(baseUrl + "/bid/plan", data)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 查询采购计划类型字典
 */
const getBidTypeDic = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/plan/dict/type", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


/*
 ** 作废采购计划列表一条数据 gaa 20200806
 */
 const abandbidPlan = data => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/bid/plan/discard", data,true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//查询一条采购计划
const getbidPlandetail = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/plan/detail", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//查询采购计划计划项列表
const getOnePlanItems = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/plan/items", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//查询采购计划计划项列表
const getprojectGeneral = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/plan/single", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 保存一条采购计划
const savebidPlan = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/bid/plan", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 更新一条采购计划
const updatebidPlan = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/bid/plan", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};
//获取采购计划里的项目
const getProjects = (param) => {
    return new Promise((resolve, reject) => {
        http.get(baseUrl +"/bid/plan/project", param, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};

//根据项目部获取采购计划事项
const getBidPlanNos = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/plan/project/item/code", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//根据项目部获取采购计划事项
const getSubProjects = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/plan/project/item", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//审批通过后，上传采购计划附件
const insertPlanAfterAudit = param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/bid/plan/attachment", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//删除采购计划上传的附件
const deletePlanAfterAudit = data => {
    return new Promise((resolve, reject) => {
        http
            .delete(baseUrl + "/bid/plan/attachment", data)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//导出采购计划
const exportListApi = param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/bid/plan/export", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


//控制价列表
const getContralPrice = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/price/list", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 删除控制价列表一条数据
 */
 const deletecontrolPrice = data => {
    return new Promise((resolve, reject) => {
        http
            .delete(baseUrl + "/bid/price", data)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 作废控制价列表一条数据 gaa 20200806
 */
 const abandcontrolPrice = data => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/bid/price/discard", data,true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//查询一条控制价
const getcontrolPricedetail = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/price/detail", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 保存一条控制价
const savecontrolPrice = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/bid/price", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 更新一条控制价
const updatecontrolPrice = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/bid/price", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 更新一条控制价打印信息
const updatecontrolPricePrint = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/bid/price/print", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//审批通过后，上传控制价附件
const insertPriceAfterAudit = param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/bid/price/attachment", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//删除控制价上传的附件
const deletePriceAfterAudit = data => {
    return new Promise((resolve, reject) => {
        http
            .delete(baseUrl + "/bid/price/attachment", data)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//采购文件列表
const getBidFile = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/file/list", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 删除采购文件列表一条数据
 */
 const deleteBidFile = data => {
    return new Promise((resolve, reject) => {
        http
            .delete(baseUrl + "/bid/file", data)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 作废采购文件列表一条数据
 */
 const abandBidFile = data => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/bid/file/discard", data,true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


//查询一条采购文件
const getBidFiledetail = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/file/detail", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 保存一条采购文件
const saveBidFile = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/bid/file", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 更新一条采购文件
const updateBidFile = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/bid/file", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


//审批通过后，上传采购文件附件
const insertFileAfterAudit = param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/bid/file/attachment", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//删除采购文件上传的附件
const deleteFileAfterAudit = data => {
    return new Promise((resolve, reject) => {
        http
            .delete(baseUrl + "/bid/file/attachment", data)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 更新一条采购文件打印信息
const updatefilePricePrint = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/bid/file/print", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


//联签单
const getBidOrder = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/signature/list", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 删除联签单列表一条数据
 */
 const deleteBidOrder = data => {
    return new Promise((resolve, reject) => {
        http
            .delete(baseUrl + "/bid/signature", data)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 作废联签单列表一条数据
 */
 const abandBidOrder = data => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/bid/signature/discard", data,true)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//查询一条联签单
const getBidOrderdetail = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/signature/detail", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 保存一条联签单
const saveBidOrder = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/bid/signature", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 更新一条联签单
const updateBidOrder = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/bid/signature", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//审批通过后，上传联签单附件
const insertOrderAfterAudit = param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/bid/signature/attachment", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//删除联签单上传的附件
const deleteOrderAfterAudit = data => {
    return new Promise((resolve, reject) => {
        http
            .delete(baseUrl + "/bid/signature/attachment", data)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 更新一条联签单打印信息
const updateorderPricePrint = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/bid/signature/print", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//采购台账
const getBidLedger = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/ledger/list", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

/*
 ** 删除采购台账列表一条数据
 */
 const deleteBidLedger = data => {
    return new Promise((resolve, reject) => {
        http
            .delete(baseUrl + "/bid/ledger", data)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//查询一条采购台账
const getBidLedgerdetail = (param, loading = false) => {
    return new Promise((resolve, reject) => {
        http
            .get(baseUrl + "/bid/ledger/detail", param, false, loading)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 保存一条采购台账
const saveBidLedger = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/bid/ledger", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// 更新一条采购台账
const updateBidLedger = reqParam => {
    return new Promise((resolve, reject) => {
        http
            .put(baseUrl + "/bid/ledger", reqParam, false)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//审批通过后，上传采购台账附件
const insertAccountAfterAudit = param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/bid/price/attachment", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//删除采购台账上传的附件
const deleteAccountAfterAudit = data => {
    return new Promise((resolve, reject) => {
        http
            .delete(baseUrl + "/bid/price/attachment", data)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};

//导出采购台账
const exportBidLedgerApi = param => {
    return new Promise((resolve, reject) => {
        http
            .post(baseUrl + "/bid/ledger/export", param)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            });
    });
};


export {
    getBidPlan, //获取控制价列表
    deletebidPlan, //删除一条数据
    abandbidPlan, //删除一条数据
    getbidPlandetail, //查询一条控制价
    getOnePlanItems,
    getprojectGeneral,
    getBidTypeDic,
    savebidPlan, //新增控制价接口
    updatebidPlan, //更新控制价接口
    getProjects,
    getBidPlanNo,  //查询采购计划编号序号
    getBidPlanNos,
    getSubProjects,
    insertPlanAfterAudit,
    deletePlanAfterAudit,
    exportListApi,

    getContralPrice, //获取采购计划列表
    deletecontrolPrice, //删除一条数据
    abandcontrolPrice, //删除一条数据
    getcontrolPricedetail, //查询一条采购计划
    savecontrolPrice, //新增采购计划接口
    updatecontrolPrice, //更新采购计划接口
    updatecontrolPricePrint,
    insertPriceAfterAudit,
    deletePriceAfterAudit,

    getBidFile, //获取控制价列表
    deleteBidFile, //删除一条数据
    abandBidFile, //删除一条数据
    getBidFiledetail, //查询一条控制价
    saveBidFile, //新增控制价接口
    updateBidFile, //更新控制价接口 
    insertFileAfterAudit,
    deleteFileAfterAudit,
    updatefilePricePrint,
    
    getBidOrder, //获取联签单列表
    deleteBidOrder, //删除一条数据
    abandBidOrder, //删除一条数据
    getBidOrderdetail, //查询一条联签单
    saveBidOrder, //新增联签单接口
    updateBidOrder, //更新联签单接口 
    insertOrderAfterAudit,
    deleteOrderAfterAudit,
    updateorderPricePrint,

    getBidLedger, //获取联签单列表
    deleteBidLedger, //删除一条数据
    getBidLedgerdetail, //查询一条联签单
    saveBidLedger, //新增联签单接口
    updateBidLedger, //更新联签单接口 
    insertAccountAfterAudit,
    deleteAccountAfterAudit,
    exportBidLedgerApi,

};
